export default "__VITE_ASSET__BJQ9xKuF__"